import { render, staticRenderFns } from "./suggestionsListAwardsAdder.vue.html?vue&type=template&id=298850d0&"
import script from "./suggestionsListAwardsAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListAwardsAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports